import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75f392b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  height: "250",
  width: "200",
  class: "figure-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "60",
  y1: "20",
  x2: "140",
  y2: "20"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "140",
  y1: "20",
  x2: "140",
  y2: "50"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "60",
  y1: "20",
  x2: "60",
  y2: "230"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "20",
  y1: "230",
  x2: "100",
  y2: "230"
}, null, -1))
const _hoisted_6 = {
  cx: "140",
  cy: "70",
  r: "20"
}
const _hoisted_7 = {
  x1: "140",
  y1: "90",
  x2: "140",
  y2: "150"
}
const _hoisted_8 = {
  x1: "140",
  y1: "120",
  x2: "120",
  y2: "100"
}
const _hoisted_9 = {
  x1: "140",
  y1: "120",
  x2: "160",
  y2: "100"
}
const _hoisted_10 = {
  x1: "140",
  y1: "150",
  x2: "120",
  y2: "180"
}
const _hoisted_11 = {
  x1: "140",
  y1: "150",
  x2: "160",
  y2: "180"
}

import {computed} from 'vue'
import {useStore} from 'vuex'

export default /*#__PURE__*/_defineComponent({
  __name: 'VisualGame',
  setup(__props) {

const store = useStore();

const figura = computed(() => store.getters.getWrongLetters)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _withDirectives(_createElementVNode("circle", _hoisted_6, null, 512), [
      [_vShow, figura.value[0]]
    ]),
    _withDirectives(_createElementVNode("line", _hoisted_7, null, 512), [
      [_vShow, figura.value[1]]
    ]),
    _withDirectives(_createElementVNode("line", _hoisted_8, null, 512), [
      [_vShow, figura.value[2]]
    ]),
    _withDirectives(_createElementVNode("line", _hoisted_9, null, 512), [
      [_vShow, figura.value[3]]
    ]),
    _withDirectives(_createElementVNode("line", _hoisted_10, null, 512), [
      [_vShow, figura.value[4]]
    ]),
    _withDirectives(_createElementVNode("line", _hoisted_11, null, 512), [
      [_vShow, figura.value[5]]
    ])
  ]))
}
}

})